const comments = [
  {
    name: '星河漫步者',
    text: '用了桃花影院三年了，真的是良心网站。资源更新快，画质清晰，关键是完全免费不要会员，安利给身边所有朋友了！',
    date: '3天前',
    avatar: '星',
    color: 'bg-primary-500',
  },
  {
    name: '追剧小达人',
    text: '作为一个重度追剧患者，桃花影院救我于水火。韩剧美剧国产剧一网打尽，再也不用东找西找了。移动端体验也很棒，通勤路上看剧很方便。',
    date: '5天前',
    avatar: '追',
    color: 'bg-accent-500',
  },
  {
    name: '光影捕手',
    text: '老用户了。从当初只有几百部资源到现在两万多部，看着桃花影院一步步成长。分类越来越细，推荐也越来越精准，希望越做越好。',
    date: '1周前',
    avatar: '影',
    color: 'bg-secondary-500',
  },
  {
    name: '深夜电影控',
    text: '半夜睡不着随便点开桃花影院，结果一口气看了三部。资源真的太全了，很多冷门片都能找到，比那些收费平台还强。',
    date: '1周前',
    avatar: '夜',
    color: 'bg-primary-700',
  },
  {
    name: '全家观影团',
    text: '周末家庭观影必备！动画片专区孩子喜欢，我和老公看大片，爸妈看纪录片，一家人的娱乐需求都满足了。而且真的不卡，很流畅。',
    date: '2周前',
    avatar: '家',
    color: 'bg-accent-600',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          观众心声
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-[480px] mx-auto">
          来自真实用户的观影感受与评价
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {comments.slice(0, 3).map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 border border-background-200/70 rounded-2xl p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full ${comment.color} text-background-50 font-heading text-sm font-bold flex-shrink-0`}>
                  {comment.avatar}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-[11px] text-foreground-400">{comment.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {comments.slice(3).map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 border border-background-200/70 rounded-2xl p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full ${comment.color} text-background-50 font-heading text-sm font-bold flex-shrink-0`}>
                  {comment.avatar}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-[11px] text-foreground-400">{comment.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}